import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import { authMiddleware, initializeAuth } from '../middleware/authMiddleware';

const store = configureStore({
    reducer: {
        auth: authReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(authMiddleware),
});

// Initialize auth state immediately after store creation
initializeAuth(store);

export default store;
